import React from "react";
import { CustomTextField } from "../formsComponents";
import { InputAdornment, SxProps } from "@mui/material";
import { Theme } from "@emotion/react";
import { AttachMoney, Percent } from "@mui/icons-material";

interface ICurrencyTextFieldProps {
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
  value: any;
  showInputProps?: "dollar" | "percent";
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  formatWithCommas?: boolean; // ✅ NEW PROP
  onChange?: (newValue: string) => void;
}

export const CurrencyTextField: React.FC<ICurrencyTextFieldProps> = (props) => {
  const {
    value,
    fullWidth,
    sx,
    onChange,
    showInputProps = "dollar",
    placeholder,
    error,
    helperText,
    formatWithCommas = true, // ✅ default true
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Remove non-numeric characters except decimal
    const sanitizedValue = inputValue.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point
    const parts = sanitizedValue.split(".");
    if (parts.length > 2) return;

    // ✅ Only format if enabled
    if (formatWithCommas && parts[0]) {
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    if (onChange) {
      onChange(parts.join("."));
    }
  };

  return (
    <CustomTextField
      fullWidth={fullWidth}
      sx={sx}
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      helperText={helperText}
      error={error}
      InputProps={
        showInputProps === "dollar"
          ? {
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              ),
            }
          : {
              startAdornment: (
                <InputAdornment position="start">
                  <Percent />
                </InputAdornment>
              ),
            }
      }
    />
  );
};
